import { useRef, useState } from "react";
import { Play } from "lucide-react";
import "./Video.css";
import thumbnail from "../../../assests/images/video-thumbnail.png"; // 👉 Replace with thumbnail image path

const VideoPlayer = ({ src, thumbnail }) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
    videoRef.current.play();
  };

  return (
    <div className="video-component-main">
      {/* Thumbnail Layer */}
      {!isPlaying && (
        <div
          onClick={handlePlay}
          className="thumbnail-layer"
          style={{
            backgroundImage: `url(${thumbnail})`, // 👉 Replace with thumbnail image
          }}
        >
          {/* Play Icon */}
          <Play
            size={60}
            color="white"
            style={{ filter: "drop-shadow(0 0 5px black)" }}
          />
        </div>
      )}

      {/* Video */}
      <video
        ref={videoRef}
        // src="https://d19gginjjv5et9.cloudfront.net/Jack_Video_04_12_2025.mp4"
        src={src}
        controls
        className="video-element"
        onPlay={() => setIsPlaying(true)}
      />
    </div>
  );
};
export default VideoPlayer;
